// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1tww7","Label":"BuildControl_Label__tdLU4","Less":"BuildControl_Less__218G7","More":"BuildControl_More__sbhy-"};